<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>send</v-icon> Advertencia
      </v-card-title>
      <v-card-text>
        <h3>¿Está seguro de enviar el permiso::?</h3>
        <br />
        <h4>Nota: Ya no podrá realizar cambios</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()"> No </v-btn>
        <v-btn
          color="success"
          @click.prevent="enviarPermiso()"
          :loading="loading"
        >
          Sí
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      id: null,
      id_persona: null,
      rol: {}
      //id_rol: null
    };
  },
  mounted() {
    this.$bus.$on("openDialogEnviarPermiso", item => {
      this.id = item.permiso.id;

      this.permiso = item;
      this.dialog = true;
      //this.obtenerRol();
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.$bus.$emit("closeDialogEnviarPermiso");
    },
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: `NOTIFICACIÓN SOLICITUD DE PERMISO`,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
    async enviarPermiso() {
      let correcto;
      let user = this.$storage.get("user");
      let id_persona = null;
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      if (this.$route.params.id !== undefined) {
        id_persona = parseInt(this.$route.params.id);
      }
      if (id_persona != null) {
        try {
          if (this.permiso.id_tipo_permiso == 96) {
            this.id = parseInt(this.id);
            user.id = parseInt(user.id);
            // console.log(`
            //                     query{
            //                         runQuery(consulta:"select control.fn_aprueba_permiso_rrhh(${this.id},${id_persona},7,${user.id})"){
            //                           respuesta
            //                         }
            //                       }
            //                   `)
            let respuesta = await this.$service.graphql({
              query: `
                                query{
                                    runQuery(consulta:"select control.fn_aprueba_permiso_rrhh(${this.id},${id_persona},7,${user.id})"){
                                      respuesta
                                    }
                                  }	
                              `
            });

            let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_rrhh;
            let resp2 = resp.split("|");
            let correcto2 = resp2[0];

            if (correcto2 == "1") {
              this.permiso.id_estado = 7;
              this.$confirm("El permiso fue aprobado", () => {});
            } else {
              this.$confirm(resp2[1], () => {});
            }

            this.close();
          } else {
            let respuesta = await this.$service.graphql({
              query: `
								query{
									runQuery(consulta:"select control.fn_aprueba_permiso_rrhh(${this.id},${id_persona},7,${user.id})"){
									respuesta
									}
								}
								`
            });

            let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_rrhh;

            let resps = resp.split("|");
            let correcto = resps[0];

            if (correcto === "1") {
              this.$confirm("El permiso fue aprobado", () => {});
            } else {
              this.$confirm(resps[1], () => {});
            }
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 96) {
        try {
          this.id = parseInt(this.id);
          user.id = parseInt(user.id);
          let respuesta = await this.$service.graphql({
            query: `
                                query{
                                    runQuery(consulta:"select control.fn_solicita_anula_permiso(${
                                      this.id
                                    },6,${user.id},${this.getUserId()},'')"){
                                      respuesta
                                    }
                                  }	
                              `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_anula_permiso;
          let resp2 = resp.split("|");
          let correcto2 = resp2[0];

          if (correcto2 == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            // this.$message.error(resp)
            this.$confirm(resp2[1], () => {});
          }

          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 8) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
                                        query{
                                          runQuery(consulta:"select control.fn_solicita_justifica_caja(${this.id},6,${user.id})"){
                                          respuesta
                                          }
                                        }
                                        `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_justifica_caja;
          let resp2 = resp.split("|");
          if (resp2[0] === "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resp2[1], () => {});
          }
          this.close();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }
      if (this.permiso.id_tipo_permiso == 12) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_envia_permiso_matrimonio(${
                  this.id
                },6,${user.id},${this.getUserId()})"){
                respuesta
                }
              }
              `
          });

          respuesta =
            respuesta.runQuery.respuesta[0].fn_envia_permiso_matrimonio;
          let resps = respuesta.split("|");
          let correcto = resps[0];

          if (correcto === "1") {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resps[1], () => {});
          }
          this.close();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }
      if (this.permiso.id_tipo_permiso == 88) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
                                          query{
                                            runQuery(consulta:"select control.fn_envia_permiso_particular(${
                                              this.id
                                            },6,${
              user.id
            },${this.getUserId()})"){
                                              
                                            respuesta
                                            }
                                          }
                                          `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_envia_permiso_particular;
          resp = resp.split("|");
          let correcto = resp[0];

          if (correcto == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resp[1], () => {});
          }

          this.close();
          //location.reload();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }
      if (this.permiso.id_tipo_permiso == 94) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_envia_permiso_particular(${
                  this.id
                },6,${user.id},${this.getUserId()})"){
                  
                respuesta
                }
              }
              `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_envia_permiso_particular;
          resp = resp.split("|");
          let correcto = resp[0];

          if (correcto == "1") {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resp[1], () => {});
          }
          this.close();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }
      //Enviar permiso cumpleaños p89
      if (this.permiso.id_tipo_permiso == 89) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${
                this.id
              },6,${user.id},${this.getUserId()})"){
                
              respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          if (correcto == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("Actualizacion de datos exitosa! " + resp, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      // asueto dia de la mujer p100
      if (this.permiso.id_tipo_permiso == 100) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${
                this.id
              },6,${user.id},${this.getUserId()})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm(mensaje, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      // Permiso dia de la mmadre p99
      if (this.permiso.id_tipo_permiso == 99) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${
                this.id
              },6,${user.id},${this.getUserId()})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm(mensaje, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      // Permiso dia del padre p98
      if (this.permiso.id_tipo_permiso == 98) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${
                this.id
              },6,${user.id},${this.getUserId()})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm(mensaje, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      // Asueto otros p101
      if (this.permiso.id_tipo_permiso == 101) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${
                this.id
              },6,${user.id},${this.getUserId()})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm(mensaje, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      // Permiso CENSO
      if (this.permiso.id_tipo_permiso == 5) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_solicita_permiso_censo_2024(${this.id},${user.id})"){
                respuesta
              }
            }
            `
          });
          let resp =
            respuesta.runQuery.respuesta[0].fn_solicita_permiso_censo_2024;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$alert(mensaje, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
      await this.enviarCorreoDestinatario(permiso_copia);
      this.close();
    },

    getUserId() {
      const user = this.$storage.get("user");
      return parseInt(user.id_persona);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/EnviarPermiso.vue